import {METHOD, request} from "../utils/request";
import {USER_INFO,LOGOUT} from "./api";

export async function getUserInfo() {
    return request(USER_INFO, METHOD.GET)
}
export async function doLogout() {
    return request(LOGOUT, METHOD.POST)
}
